import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ErrorReportService {
  private currentUrl: string = '';
  private readonly BASE_REPORT_URL = 'https://chatt.varden.se/report-error';

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
        this.currentUrl = window.location.href;
      });
      this.currentUrl = window.location.href;
    }
  }

  public openErrorReportPage(newWindow: boolean = true): void {
    if (isPlatformBrowser(this.platformId)) {
      const fullUrl = this.buildReportUrl();
      if (newWindow) {
        window.open(fullUrl, '_blank');
      } else {
        window.location.href = fullUrl;
      }
    }
  }

  private buildReportUrl(): string {
    return `${this.BASE_REPORT_URL}?url=${encodeURI(this.currentUrl)}`;
  }
}
